import { AbstractControl } from '@angular/forms';

export class PasswordValidator {
    static comparePasswords(control: AbstractControl) {
        let newPwdControl = control.get('password');
        let confirmPwdControl = control.get('confirmPwd'); 
        if (confirmPwdControl.errors && !confirmPwdControl.errors.pwdsDontMatch) {
          // return if another validator has already found an error on the matchingControl
          return;
        }
        if (newPwdControl.value !== confirmPwdControl.value) {
          confirmPwdControl.setErrors({ pwdsDontMatch: true });
          // return { pwdsDontMatch: true };
        }
        else {
          confirmPwdControl.setErrors(null);
        }
      }
}
